import React, { useEffect, useState, useRef } from 'react'
import moment from 'moment'
import _ from 'lodash'
import {
 Drawer, Dropdown, Menu, Button,
} from 'antd'
import {
 P, Div, H3, Icon, H4, SmallText, Input,
} from 'konsys-ui'
import { useLazyQuery, useQuery } from '@apollo/react-hooks'
import {
  JOB_LIST, GET_JOB,
} from '../../../constants/graphql/query'
import { MYINFO } from '../../../constants/graph/query'
import { theme } from '../../../styles/_variables'
import { CardStyled } from '../../shipping-order-page/styled'
import { Loading } from '../../../components/common'
import {
  DetailModal, DropdownSelector,
} from '../../../components/job-components'
import { mappingValueToText } from '../detail/component-renderer'

const { color } = theme

const Card = ({
  data,
}) => {
  const [width, setWidth] = useState(0)
  const [detailModal, setDetailModal] = useState(false)
  const parentRef = useRef(null)
  const [getInfo, {
    data: info, loading, refetch,
  }] = useLazyQuery(GET_JOB)

  const menu = (
    <Menu onClick={(e) => {
      if (e?.key === 'detail') {
        getInfo({ variables: { id: `${data.id}` } })
        setDetailModal(true)
      }
    }}>
      <Menu.Item key="detail">
        ดูรายละเอียด
      </Menu.Item>
    </Menu>
  )

  useEffect(() => {
    if (parentRef.current) {
        setWidth(parentRef?.current?.offsetWidth)
    }
}, [parentRef])

  return (
    <CardStyled id='list-card' ref={parentRef} display='flex' flexDirection='column' padding='8px 16px' margin='8px 0' width='100%' style={{ overflow: 'hidden' }}>
      <DetailModal
        jobDetailData={info}
        visible={detailModal}
        setVisible={setDetailModal}
      />
      <Div justifyContent='space-between' width='100%' alignItems='center' display='flex' margin='0 0 16px 0'>
        <Div alignItems='center' display='flex' width='calc(100% - 100px)'>
          <Icon icon='far fa-file-alt' color={theme.color.primaryColor} fontSize='20px' margin='0 16px 0 0'/>
          <Div alignItems='flex-start' display='flex' flexDirection='column' justifyContent='flex-start'>
            <H4 bold>{data?.number}</H4>
          </Div>
        </Div>
        <Dropdown overlay={menu} trigger={['click']} on>
          <Icon icon='far fa-ellipsis-h' color={theme.color.primaryColor} fontSize='17px' style={{ marginLeft: 8 }}/>
        </Dropdown>
      </Div>
      <Div justifyContent='space-between' width='100%' alignItems='flex-end' display='flex' margin='0 0 16px 0'>
        <Div width='100%'>
          <Div width='100%' alignItems='center' display='flex' margin='0 0 8px 0'>
            <Icon icon='far fa-boxes' color={theme.color.primaryColor} fontSize='20px' margin='0 16px 0 0'/>
            <SmallText color={theme.color.coolGrey}>{data?.cargo || '-'}</SmallText>
          </Div>
          <Div width='100%' alignItems='center' display='flex'>
            <Icon icon={data?.dealType === 'PERWEIGHT' ? 'far fa-weight-hanging' : 'far fa-truck-moving'} color={theme.color.primaryColor} fontSize='20px' margin='0 16px 0 0'/>
            <SmallText margin='0 0 0 10px' color={theme.color.coolGrey}>{data?.dealType === 'PERWEIGHT' ? 'ต่อน้ำหนัก' : 'ต่อเที่ยว'}</SmallText>
          </Div>
        </Div>
        <Div width='100%' alignItems='center' display='flex' justifyContent='flex-end'>
          <SmallText margin='0 0 0 10px' color={theme.color.coolGrey}>{moment(data?.contractEnd).format('DD/MM/YYYY')}</SmallText>
        </Div>
      </Div>
      {

      }
      <Div width='100%' alignItems='center' display='flex' justifyContent='center'>
        <SmallText margin='0 0 0 10px' color={theme.color.coolGrey}>{data?.deliveredWeight} / {data?.contractWeight} {data?.dealType === 'PERWEIGHT' ? mappingValueToText(data?.unit) : 'เที่ยว'}</SmallText>
      </Div>
      <Div margin='0 0 -8px -16px' width={`${data?.contractWeight > 0 ? width * data?.deliveredWeight / data?.contractWeight > width ? width : width * data?.deliveredWeight / data?.contractWeight : 0}px`} height='5px' bgColor={theme.color.secondaryColor} />
    </CardStyled>
  )
}

export const MobileJobList = (props) => {
  const [doGetJobs, {
    data, loading, fetchMore,
  }] = useLazyQuery(JOB_LIST, {
    variables: {
      orderBy: 'DESC',
      orderField: 'updatedAt',
    },
  })

  const [search, setSearch] = useState(false)

  const [number, setNumber] = useState()
  const [cargo, setCargo] = useState()
  const [companyName, setCompanyName] = useState('')
  const [dealType, setDealType] = useState('ALL')

  const {
    data: myInfo, loading: myInfoLoading,
  } = useQuery(MYINFO)

  useEffect(() => {
    doGetJobs({ variables: { limit: 10, offset: 0 } })
  }, [])

  return (
    <Div display='flex' flexDirection='column'>
      <Drawer
        title='ค้นหา'
        placement='top'
        closable={false}
        onClose={() => setSearch(false)}
        visible={search}
        height={350}
      >
      {
        myInfo?.myInfo?.Customer
        && <Div display='flex' margin='4px 0' alignItems='center' justifyContent='space-between'>
          <P>ผู้จ้าง</P>
          <DropdownSelector
            key='filter'
            data={myInfo?.myInfo?.Customer?.map(customer => ({ value: customer.companyName, text: customer.companyName }))}
            moreProps={{ value: companyName, style: { width: '250px' }, defaultValue: '' }}
            handleChange={e => setCompanyName(e)}
            filter={true}
          />
        </Div>
      }
        <Div display='flex' margin='4px 0' alignItems='center' justifyContent='space-between'>
          <P>เลขที่</P>
          <Input width='50%' value={number} onChange={e => setNumber(e.target.value)} />
        </Div>
        <Div display='flex' margin='4px 0' alignItems='center' justifyContent='space-between'>
          <P>ประเภทสินค้า</P>
          <Input value={cargo} width='50%' onChange={e => setCargo(e.target.value)} />
        </Div>
        <Div display='flex' margin='4px 0' alignItems='center' justifyContent='space-between'>
          <P>ประเภทสัญญางาน</P>
          <DropdownSelector
            width='50%'
            key='filter'
            data={[{ value: 'ALL', text: 'ทั้งหมด' }, { value: 'PERWEIGHT', text: 'ต่อน้ำหนัก' }, { value: 'PERTRIP', text: 'ต่อเที่ยว' }]}
            moreProps={{ value: dealType }}
            handleChange={e => setDealType(e || 'ALL')}
            filter={true}
            statusAttr='ทั้งหมด'
          />
        </Div>
        <div
          style={{
            textAlign: 'right',
            alignSelf: 'flex-end',
            marginTop: 8,
          }}
        >
          <Button
            onClick={() => {
              doGetJobs({ variables: { limit: 10, offset: 0 } })
              setNumber('')
              setCargo('')
              setCompanyName('')
              setDealType('ALL')
              setSearch(false)
            }}
            style={{ marginRight: 8 }}
          >
            ล้างค่า
          </Button>
          <Button
            onClick={() => {
              doGetJobs({
                variables: {
                  limit: 10,
                  offset: 0,
                  number,
                  cargo,
                  dealType,
                  companyName,
                },
              })
              setSearch(false)
              }
            }
            type="primary"
          >
            ค้นหา
          </Button>
        </div>
      </Drawer>
      <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
        <H3 bold color={color.primaryColor} margin='32px 0'>รายการสัญญางาน</H3>
        <Div display='flex' flexDirection='row' alignItems='center'>
          <Icon icon='far fa-search' fontSize='25px' color={theme.color.primaryColor} onClick={() => setSearch(true)}/>
        </Div>
      </Div>
      <Div
        margin='-8px 0'
        height='calc(100vh - 266px)'
        style={{ overflowY: 'auto' }}
        onScroll={(e) => {
          if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight && data.JobList.lists.length < data.JobList.totalFilter) {
            fetchMore({
              variables: {
                offset: data.JobList.lists.length,
                limit: 10,
              },
              updateQuery: (prev, { fetchMoreResult }) => {
                if (!fetchMoreResult) return prev
                const newData = {
                  ...prev,
                  JobList: {
                    ...prev.JobList,
                    lists: [
                      ...prev.JobList.lists,
                      ...fetchMoreResult.JobList.lists,
                    ],
                  },
                }
                return { ...newData }
              },
            })
          }
        }}
      >
        {
          _.isEmpty(data?.JobList?.lists)
          ? <P bold color={theme.color.purplishGrey}>ไม่พบรายการที่ค้นหา</P>
          : data?.JobList?.lists.map(job => (
              <Card key={job.id} data={job} myInfo={myInfo}/>
            ))
        }
      </Div>
      {loading && <Loading />}
    </Div>
  )
}

export default MobileJobList
